import type { ReactNode } from "react";
import Nav from "./Nav";

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Nav />
      <main className="flex-1 max-w-5xl mx-auto w-full px-4 pt-10 pb-10">{children}</main>
      <footer className="border-t border-surface text-center text-sm py-6 text-gray-400">
        <span>© {new Date().getFullYear()} Nguyễn Nhật Duy</span>
      </footer>
    </div>
  );
}
